module.exports = __webpack_public_path__ + "static/491bee12.BrazilBannerCenter.png";